import React from 'react';
import { parseTextWithUrls } from '../utils/linkUtils';
import ImagePreview from './ImagePreview';

/**
 * Component that renders text with URLs converted to clickable links
 * @param {Object} props
 * @param {string} props.text - The text to render with URLs as links
 * @param {string} props.className - Optional CSS class to apply to the container
 * @param {boolean} props.showImagePreviews - Whether to show image previews for URLs
 * @returns {JSX.Element}
 */
const LinkText = ({ text, className = '', showImagePreviews = false }) => {
  if (!text) {
    return null;
  }

  const segments = parseTextWithUrls(text);

  return (
    <span className={className}>
      {segments.map((segment, index) => {
        if (segment.type === 'url') {
          return (
            <span key={index} className="link-with-preview">
              {showImagePreviews && (
                <ImagePreview
                  url={segment.href}
                  className="mb-2"
                />
              )}
              <a
                href={segment.href}
                target="_blank"
                rel="noopener noreferrer"
                className="link-in-text"
              >
                {segment.content}
              </a>
            </span>
          );
        } else {
          return (
            <span key={index}>
              {segment.content}
            </span>
          );
        }
      })}
    </span>
  );
};

export default LinkText;